<template>
  <div
    class="content"
    v-if="result"
  >
    <div class="wrap">
      <div class="card">
        <div class="top">
          <div class="left">
            <div class="label">今日使用人次</div>
            <div class="count">{{result.today_user_statistic.count_use_now}}人</div>
          </div>
          <div class="right">
            <img
              src="@/assets/img/adjust_home_icon1.png"
              alt=""
              srcset=""
            >
          </div>
        </div>
        <div class="line"></div>
        <div class="bottom"
        v-if="result.today_user_statistic.count_use_now_than_before>=0"
        >
          <span style="margin-right:16px;">比昨日新增</span>
          <span>{{result.today_user_statistic.count_use_now_than_before}}人</span>
          <img
            src="@/assets/img/rise1.png"
            alt=""
            srcset=""
          >
        </div>
        <div class="bottom"
        v-else
        >
          <span style="margin-right:16px;">比昨日下降</span>
          <span>{{result.today_user_statistic.count_use_now_than_before}}人</span>
          <img
            src="@/assets/img/drop1.png"
            alt=""
            srcset=""
          >
        </div>
      </div>
      <div class="card margin">

        <div class="top">
          <div class="left">
            <div class="label">今日解锁人次</div>
            <div class="count">{{result.today_user_statistic.count_vip_now}}人</div>
          </div>
          <div class="right">
            <img
              src="@/assets/img/adjust_home_icon2.png"
              alt=""
              srcset=""
            >
          </div>
        </div>
        <div class="line"></div>
        <div class="bottom"
        v-if="result.today_user_statistic.count_vip_now_than_before>=0"
        >
          <span style="margin-right:16px;">比昨日新增</span>
          <span>{{result.today_user_statistic.count_vip_now_than_before}}人</span>
          <img
            src="@/assets/img/rise1.png"
            alt=""
            srcset=""
          >
        </div>
        <div class="bottom"
        v-else
        >
          <span style="margin-right:16px;">比昨日下降</span>
          <span>{{result.today_user_statistic.count_vip_now_than_before}}人</span>
          <img
            src="@/assets/img/drop1.png"
            alt=""
            srcset=""
          >
        </div>
      </div>
      <div class="card">
        <div class="top">
          <div class="left">
            <div class="label">今日生成报告人次</div>
            <div class="count">{{result.today_user_statistic.count_svip_now}}人</div>
          </div>
          <div class="right">
            <img
              src="@/assets/img/adjust_home_icon3.png"
              alt=""
              srcset=""
            >
          </div>
        </div>
        <div class="line"></div>
        <div class="bottom"
        v-if="result.today_user_statistic.count_svip_now_than_before>=0"
        >
          <span style="margin-right:16px;">比昨日新增</span>
          <span>{{result.today_user_statistic.count_svip_now_than_before}}人</span>
          <img
            src="@/assets/img/rise1.png"
            alt=""
            srcset=""
          >
   
        </div>
        <div class="bottom"
        v-else
        >
          <span style="margin-right:16px;">比昨日下降</span>
          <span>{{result.today_user_statistic.count_svip_now_than_before}}人</span>
          <img
            src="@/assets/img/drop1.png"
            alt=""
            srcset=""
          >
        </div>
      </div>
    </div>
    <div
      class="wrap"
      style="margin-top:16px;"
    >

      <!-- 本周 -->
      <div class="card other">
        <div class="card-header">
          <div class="left">
            <div class="line"></div>
            <div class="title">本周</div>
          </div>
          <div class="right">
            <el-date-picker
              v-model="weektime"
              type="week"
              format="yyyy 第 WW 周"
              placeholder="选择周"
              @change="weektimeChange"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="card-main">
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.week_user_statistic.count_use_now}}人</div>
              <div class="label">使用人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上周</div>
              <div
                class="value"
                v-if="result.week_user_statistic.percent_use_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.week_user_statistic.percent_use_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.week_user_statistic.percent_use_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.week_user_statistic.count_vip_now}}人</div>
              <div class="label">解锁人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上周</div>
              <div
                class="value"
                v-if="result.week_user_statistic.percent_vip_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.week_user_statistic.percent_vip_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.week_user_statistic.percent_vip_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.week_user_statistic.count_svip_now}}人</div>
              <div class="label">生成报告人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上周</div>
              <div
                class="value"
                v-if="result.week_user_statistic.percent_svip_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.week_user_statistic.percent_svip_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.week_user_statistic.percent_svip_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 本月 -->
      <div class="card other margin">
        <div class="card-header">
          <div class="left">
            <div class="line"></div>
            <div class="title">本月</div>
          </div>
          <div class="right">
            <el-date-picker
              v-model="monthtime"
              type="month"
              placeholder="选择月"
              @change="monthtimeChange"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="card-main">
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.month_user_statistic.count_use_now}}人</div>
              <div class="label">使用人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上月</div>
              <div
                class="value"
                v-if="result.month_user_statistic.percent_use_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.month_user_statistic.percent_use_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.month_user_statistic.percent_use_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.month_user_statistic.count_vip_now}}人</div>
              <div class="label">解锁人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上月</div>
              <div
                class="value"
                v-if="result.month_user_statistic.percent_use_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.month_user_statistic.percent_vip_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.month_user_statistic.percent_vip_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.month_user_statistic.count_svip_now}}人</div>
              <div class="label">生成报告人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上月</div>
              <div
                class="value"
                v-if="result.month_user_statistic.percent_use_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.month_user_statistic.percent_svip_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.month_user_statistic.percent_svip_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 合计 -->
      <div class="card other">
        <div class="card-header">
          <div class="left">
            <div class="line"></div>
            <div class="title">合计</div>
          </div>
        </div>
        <div class="card-main">
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.total_user_statistic.count_use_now}}人</div>

              <div class="label">使用人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上周</div>
              <div
                class="value"
                v-if="result.total_user_statistic.percent_use_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.total_user_statistic.percent_use_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.total_user_statistic.percent_use_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.total_user_statistic.count_vip_now}}人</div>

              <div class="label">解锁人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上周</div>
              <div
                class="value"
                v-if="result.total_user_statistic.percent_use_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.total_user_statistic.percent_vip_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.total_user_statistic.percent_vip_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <div class="value">{{result.total_user_statistic.count_svip_now}}人</div>

              <div class="label">生成报告人次</div>
            </div>
            <div class="item-right">
              <div class="label">较上周</div>
              <div
                class="value"
                v-if="result.total_user_statistic.percent_use_now_than_before>=0"
              >
                <img
                  src="@/assets/img/rise2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent">{{Number((result.total_user_statistic.percent_svip_now_than_before*100).toFixed(1))}}%</div>
              </div>
              <div
                class="value"
                v-else
              >
                <img
                  src="@/assets/img/drop2.png"
                  alt=""
                  srcset=""
                >
                <div class="percent other">{{Number((result.total_user_statistic.percent_svip_now_than_before*100).toFixed(1))}}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
  
<script>
import { adjustStatistics } from "@/api/adjust";

export default {
  components: {
  },
  data() {
    return {
      result: null,
      weektime: '',
      query: {

      },
      monthtime: '',
    };
  },
  created() {
    this.fetchContent()
  },
  methods: {
    // 内容数据
    fetchContent() {
      adjustStatistics(this.query).then((res) => {
        this.result = res.user_statistic
      });
    },
    weektimeChange(e) {
      this.$set(this.query, 'week_now_time', e.getTime())
      this.fetchContent()
    },
    monthtimeChange(e) {
      this.$set(this.query, 'month_now_time', e.getTime())
      this.fetchContent()
    }
  }
};
</script>
  
<style lang="less" scoped>
.content {
  padding: 30px;
  overflow-y: hidden;
}
.wrap {
  display: flex;
  .card {
    padding: 32px;
    flex: 1;
    background: #ffffff;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        .label {
          font-size: 18px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.9);
          margin-bottom: 16px;
        }
        .count {
          font-size: 40px;
          font-family: DINPro-Bold, DINPro;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.9);
        }
      }
      .right {
        img {
          width: 86px;
          height: 86px;
        }
      }
    }
    .bottom {
      span {
        font-size: 16px;
        font-weight: 400;
        color: #a0a0a0;
      }
      img {
        width: 18px;
        margin-left: 4px;
        height: 9px;
      }
    }
    .line {
      height: 1px;
      background: #dcdcdc;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      margin-top: 24px;
      margin-bottom: 20px;
    }
  }
  .other {
    padding: 0px;
    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px #d4d4d4 solid;
      padding-right: 16px;
      .left {
        display: flex;
        align-items: center;
        .line {
          width: 4px;
          height: 24px;
          background: #266fe8;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          margin-right: 28px;
        }
        .title {
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;

          color: rgba(0, 0, 0, 0.9);
        }
      }
    }
    .card-main {
      padding: 0px 30px;
      .item {
        display: flex;
        justify-content: space-between;
        padding: 30px 0px;
        border-bottom: 1px solid #ebeef5;
        .item-left {
          display: flex;
          flex-direction: column;
          .value {
            font-size: 32px;
            font-family: DINPro-Bold, DINPro;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);
            margin-bottom: 16px;
          }
          .label {
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
          }
        }
        .item-right {
          display: flex;
          align-items: flex-end;
          flex-direction: column;
          margin-top: 8px;
          .label {
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.9);
            margin-bottom: 16px;
          }
          .value {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .percent {
              font-size: 24px;
              font-family: DINPro-Medium, DINPro;
              font-weight: 500;
              color: #00a870;
            }
            .other {
              color: #f36d78;
            }
            img {
              width: 27px;
              height: 33px;
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
}
.margin {
  margin: 0px 30px;
}
</style>  